import { useMemo } from "react";
import { useSnackbarQuery } from "../../hooks";
import { BuildingMedia } from "../models/BuildingMedia";
import { QUERIES } from "../queries";

export function useBuildingRoomMediaPictures(
  buildingId: string,
  type: "PICTURES" | "ICONS" = "PICTURES"
) {
  const query = useMemo(() => {
    return type === "PICTURES"
      ? QUERIES.BUILDING_ROOM_MEDIA_PICTURES
      : QUERIES.BUILDING_ROOM_MEDIA_ICON_PICTURES;
  }, [type]);

  const resultsField = useMemo(() => {
    return type === "PICTURES"
      ? "buildingRoomMediaRoomPictures"
      : "buildingRoomMediaIconPictures";
  }, [type]);

  const { data, loading, error, refetch } = useSnackbarQuery(query, {
    variables: { buildingId },
  });

  const buildingRoomMediaPictures: BuildingMedia[] | undefined = useMemo(() => {
    if (data) {
      return data[resultsField];
    }
  }, [data, resultsField]);

  return {
    buildingRoomMediaPictures,
    refetchBuildingRoomMediaPictures: refetch,
    loading,
    error,
  };
}
